import { useEffect } from 'react';
import { useAuth0, OAuthError } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

import { Loader } from '@flintmint/web-shared/components/loader';

import { capture, identify } from '@/analytics';
import { auth0Scope, parseAuth0User, saveAuthUser } from '@flintmint/web-shared/hooks/use-auth-user';

import { appRoutes } from '@/constants/routes';

export const Login = () => {
  const navigate = useNavigate();
  const { user: authUser, isLoading, loginWithRedirect, error } = useAuth0();

  useEffect(() => {
    if (authUser) {
      const user = parseAuth0User(authUser);
      saveAuthUser(authUser);
      if (user.id) {
        identify(user.id);
      }
      // Auth0 `sub` is `<connection>|<id>`, e.g. `google-oauth2|123`; the prefix is the auth method.
      capture('user_logged_in', { auth_method: authUser.sub?.split('|')[0] });
      navigate(appRoutes.home, { replace: true });
    }

    if (!authUser && !isLoading) {
      loginWithRedirect({
        authorizationParams: {
          scope: auth0Scope,
        },
      }).catch(console.error);
    }
  }, [authUser, isLoading, loginWithRedirect, navigate]);

  useEffect(() => {
    if (error) {
      capture('login_failed', { failure_reason: error instanceof OAuthError ? error.error : 'unknown' });
    }
  }, [error]);

  return <Loader fullScreen />;
};
